<template>
  <div>
    <NBar title="banner图设置" :top="true"/>
    <nut-noticebar :scrollable="false" background="#cee0ff" color="#525975" @click="show = true">
      <div>
        <span>顾客扫码所打开页面的banner图</span>
        <span>></span>
      </div>
    </nut-noticebar>
    <nut-cell :show-icon="true" style="margin-bottom: 10px;" @click.native="showSite = true">
      <span slot="title">适用场地</span>
      <span slot="desc">{{siteNames != null && siteNames != '' ? siteNames : '未设置'}}</span>
    </nut-cell>
    <!--选择场地弹窗-->
    <nut-popup v-model="showSite" position="bottom" closeable :style="{height: '80%',position:'relative'}">
      <nut-cell style="margin-top: -3px;">
        <span slot="title" style="font-size: 16px;">选择场地</span>
      </nut-cell>
      <nut-searchbar ref="siteSearch" @submit="siteSearch" v-model="siteSearchName" place-text="请输入场地名称"
                     style="margin: 10px;"/>
      <list-loading ref="addressList" :data.sync="addressList" :page.sync="page" :limit.sync="limit"
                    @loadlist="getAddressList" :is-show-mod="true" style="height: 350px;">
        <div slot="list">
          <nut-cell v-for="(item ,index) in addressList" :key="index">
            <span slot="title">{{item.name}}</span>
            <span slot="desc" style="font-size: 14px;">{{item.deviceCount + '台'}}
                <nut-checkbox v-model="item.checked" @change="selectAddress($event,item,index)"/>
            </span>
          </nut-cell>
        </div>
      </list-loading>
      <div class="bottom">
        <nut-checkbox v-model='isAll' @change="checkAll" class="bottom-checkbox">全选</nut-checkbox>
        <nut-button class="btn" small @click.native="confirm">确定({{selectSiteList.length}})</nut-button>
      </div>
    </nut-popup>
    <!--选择场地弹窗 end-->
    <div class="center">
      <nut-cell :show-icon="true" @click.native="showDeviceType = true">
        <span slot="title">适用设备</span>
        <span slot="desc">{{deviceTypeNames != null && deviceTypeNames != '' ? deviceTypeNames : '未设置'}}</span>
      </nut-cell>
      <!--选择设备类型-->
      <nut-popup v-model="showDeviceType" position="bottom" closeable :style="{height: '80%',position:'relative'}">
        <nut-cell style="margin-top: -3px;">
          <span slot="title" style="font-size: 16px;">选择设备类型</span>
        </nut-cell>
        <nut-scroller style="height: 450px;" type="vertical" :is-loading="isDeviceTypeLoading"
                      @pulldown="pullDeviceTypeDownClick">
          <div slot="list">
            <nut-cell v-for="(item ,index) in deviceTypeList" :key="index">
              <span slot="title">{{item.name}}</span>
              <span slot="desc">
                <nut-checkbox v-model="item.checked" @change="selectDeviceType($event,item,index)"/>
              </span>
            </nut-cell>
          </div>
        </nut-scroller>
        <div class="bottom">
          <nut-checkbox v-model='isDeviceTypeAll' @change="checkDeviceTypeAll" class="bottom-checkbox">全选</nut-checkbox>
          <nut-button class="btn" small @click.native="confirmDeviceType">确定({{selectDeviceTypeList.length}})
          </nut-button>
        </div>
      </nut-popup>
      <!--选择设备类型 end-->
      <nut-textinput v-model="form.name" label="banner名称：" placeholder="请输入10字以内的名称"
                     :has-border="false" :clearBtn="false" :disabled="false" class="input"/>
    </div>
    <nut-cell :show-icon="false">
      <span slot="title">上传图片</span>
      <span slot="desc">最佳上传尺寸：375px* 125px</span>
    </nut-cell>
    <div class="banner-upload" v-for="(item,index) in bannerList" :key="index">
      <nut-icon v-if="index != 0" type="cross" size="15px" class="del" @click.native="delBanner(index)"/>
      <span class="text">（支持 jpg/png 格式，500KB以内）</span>
      <nut-imagepicker @imgMsg="imgMsg($event,index)" :max="1" :width="width" style="margin-top:15px"/>
      <nut-textinput v-model="item.webUrl" label="网址：" placeholder="请输入自定义网址（选填）"
                     :has-border="false" :clearBtn="false" :disabled="false" style="flex: 1;width: 94%;"/>
    </div>
    <div class="bottom-btn">
      <nut-button small style="border-radius: 5px;" @click="addBanner()">+新增banner图</nut-button>
    </div>
    <nut-button block class="save-btn" @click="submit">保存</nut-button>
  </div>
</template>

<script>
export default {
  name: 'BannerSet',
  data () {
    return {
      width: window.screen.width - 20,
      val: '',
      bannerList: [{ imgPath: '', webUrl: '' }],
      user: {},
      addressList: [{}],
      show: false,
      imgs: [],
      form: {
        id: null,
        addressIds: [],
        merId: null,
        storeId: null,
        deviceType: null,
        name: '',
        imgUrl: '',
        url: '',
      },
      url: '',
      //是否显示选择场地
      showSite: false,
      siteSearchName: '',
      isSiteLoading: false,
      currSiteIndex: 0,
      addressList: [{}],
      isAll: false,
      selectSiteList: [],
      siteNames: '',
      page: 1,
      limit: 10,
      deviceTypeList: [],
      showDeviceType: false,
      isDeviceTypeLoading: false,
      isDeviceTypeAll: false,
      selectDeviceTypeList: [],
      deviceTypeNames: '',
    }
  },
  mounted () {
    this.user = this.$api.user
    this.form.merId = this.$api.merId
    this.form.storeId = this.$api.storeId
    this.getAddressList()
    this.findDeviceType()
  },
  methods: {
    imgMsg (data, index) {
      if (data.msg.length > 0) {
        data.msg.forEach(item => {
          this.imgs.push(item)
        })
      }
      if (data.code == 3) {
        this.imgs.splice(index, 1)
      }
    },
    //查询场地列表
    getAddressList () {
      let data = {
        page: this.page,
        limit: this.limit
      }
      if (this.siteSearchName != '') {
        data.searchName = this.siteSearchName
      }
      this.$api.post({
        url: '/device/api/device/address/list',
        data: data
      }).then(res => {
        this.$refs.addressList.setRes(res)
      })
    },
    findDeviceType () {
      this.$api.post({
        url: '/device/api/device/device-type/list',
        data: {
          page: this.page,
          limit: this.limit
        }
      }).then(res => {
        this.deviceTypeList = res.data
        this.isDeviceTypeLoading = false
      })
    },
    siteSearch (value) {
      this.siteSearchName = value
      //点击键盘中的’搜索‘时，失去焦点
      this.$refs.siteSearch.blur()
      this.getAddressList()
    },
    pullDownClick () {
      this.isSiteLoading = true
      this.getAddressList()
    },
    selectAddress (val, item, index) {
      if (val) {
        this.selectSiteList.push(item)
      } else {
        this.selectSiteList.splice(index, 1)
      }
    },
    checkAll () {
      let i
      let list = this.addressList
      if (!this.isAll) {
        for (i in list) {
          list[i].checked = false
          this.selectSiteList = []
        }
      } else {
        for (i in list) {
          list[i].checked = true
          this.selectSiteList.push(list[i])
        }
      }
    },
    confirm () {
      let siteNames = ''
      this.selectSiteList.forEach(item => {
        siteNames += item.name + ','
      })
      this.siteNames = siteNames.substring(0, siteNames.length - 1)
      this.showSite = false
    },
    pullDeviceTypeDownClick () {
      this.isDeviceTypeLoading = true
      this.findDeviceType()
    },
    selectDeviceType (val, item, index) {
      if (val) {
        this.selectDeviceTypeList.push({
          id: item.id,
          name: item.name
        })
      } else {
        this.selectDeviceTypeList.splice(index, 1)
      }
    },
    checkDeviceTypeAll () {
      let i
      let list = this.DeviceTypeList
      if (!this.isAll) {
        for (i in list) {
          list[i].checked = false
          this.selectDeviceTypeList = []
        }
      } else {
        for (i in list) {
          list[i].checked = true
          this.selectDeviceTypeList.push({
            id: list[i].id,
            name: list[i].name
          })
        }
      }
    },
    confirmDeviceType () {
      let deviceTypeNames = ''
      this.selectDeviceTypeList.forEach(item => {
        deviceTypeNames += item.name + ','
      })
      this.deviceTypeNames = deviceTypeNames.substring(0, deviceTypeNames.length - 1)
      this.showDeviceType = false
    },
    //保存
    submit: function () {
      if (this.$util.isArrOrNull(this.form.name)) {
        this.$toast.warn('请输入banner名称!')
        return
      }
      if (this.imgs != null && this.imgs.length > 0) {
        this.upload(this.imgs, 0)
      } else {
        this.save()
      }
    },
    save: function () {
      if (this.url.length > 0) {
        this.form.imgUrl = this.url.substring(0, this.url.length - 1)
      }
      //处理选中的地址
      this.selectSiteList.forEach(item => {
        this.form.addressIds.push(item.id)
      })
      //处理选中的设备类型
      this.form.deviceType = JSON.stringify(this.selectDeviceTypeList)
      let url = ''
      this.bannerList.forEach(item => {
        url += item.webUrl + ';'
      })
      this.form.url = url.substring(0, url.length - 1)
      this.$api.post({
        url: '/device/api/device/device-banner/save',
        data: this.form
      }).then(() => {
        setTimeout(() => {
          if (this.type != null) {
            this.$router.go(-2)
          } else {
            this.$router.go(-1)
          }
        }, 2000)
      })
    },
    //上传文件
    upload: function (imgs, i) {
      if (imgs[i].size / 1024 / 1024 > 2) {
        this.$toast.warn('上传图片大小不能超过 2MB')
        return false
      }
      let data = new FormData()
      let file = new File(['file'], imgs[i].path)
      data.append('file', file)
      data.append('folder', 'image')
      this.$api.upload({
        url: '/file/upload/img',
        data: data
      }).then(res => {
        i++
        this.url = this.url + res.data.filePath + ',' + res.data.fileName + ';'
        if (i < imgs.length) {
          this.upload(imgs, i, this.form)
        } else {
          this.form.imgUrl = this.url.substring(0, this.url.length - 1)
          this.save(this.form)
        }
      })
      return false
    },
    addBanner () {
      this.bannerList.push({ imgPath: '', webUrl: '' })
    },
    delBanner (index) {
      this.bannerList.splice(index, 1)
    },
  }
}
</script>

<style scoped>
  .center {
    margin: 10px 0;
    background: #fff;
  }

  .center .input {
    margin: 0 10px;
  }

  .banner-upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    padding: 10px 0;
    position: relative;
  }

  .banner-upload .text {
    color: #8994a7;
    text-align: left;
    width: 94%;
  }

  .del {
    position: absolute;
    right: 15px;
  }

  .bottom-btn {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 0 50px 0;
  }

  .bottom {
    width: 100%;
    position: fixed;
    bottom: 0;
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bottom-checkbox {
    flex: 0.8;
    text-align: center;
  }

  .bottom .btn {
    flex: 1;
    border-radius: 0;
    height: 45px;
  }

  .save-btn {
    position: fixed;
    bottom: 0;
    border-radius: 0;
  }

  >>> .nut-textinput input {
    text-align: end;
  }

  >>> .nut-imagepicker .img-list .add-icon {
    border: 1px dashed #409EFF;
  }

  >>> .nut-imagepicker .img-list .add-icon i {
    color: #409EFF;
  }

  >>> .nut-button {
    background: #409EFF;
    padding: 0 60px;
  }

  >>> .nut-checkbox input:checked {
    background-color: #409EFF;
    border-color: #409EFF;
    border-radius: 50%;
  }

  >>> .nut-checkbox.nut-checkbox-size-base input {
    border-radius: 50%;
  }

  >>> .nut-checkbox input:after {
    background: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/BannerSet.vue